import initExclusivityTags from './exclusive';
import initTagGroups from './groups';

export default function initTags(): void {
    initTagGroups();
    initExclusivityTags();
}
